import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, startWith, switchMap} from 'rxjs/operators';
import {
  FRTIffShipmentDetailResponse,
  HHGIffShipmentDetailResponse
} from 'src/app/shared/common-components/common-structure';
import {NegativeShipmentReportSubmission} from '../../features/iff-shipment/negative-shipment-report-submission/negative-shipment-report-submission';

@Injectable({
  providedIn: 'root'
})
export class IffShipmentDetailsService extends DataService {

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  // private baseURI = this.apiUri + '/iffDetailsList';
  private baseURI = this.apiUri;
  private _logger: LoggerService;
  headers = new HttpHeaders({'Content-Type': 'application/json'});

  private frtIFFShipmentDetailRequest = new BehaviorSubject<string>('');
  private hhgIFFShipmentDetailRequest = new BehaviorSubject<string>('');

  // Listens to all frt detail request and emits results for that request.
  frtIFFShipmentDetailResult$ = this.frtIFFShipmentDetailRequest.pipe(
    switchMap((iffMasterId) => {
      return this.http.get<FRTIffShipmentDetailResponse[]>(this.baseURI + '/frtiffDetails/get/' + iffMasterId + '/masterid')
        .pipe(
          catchError(e => {
            return of([] as FRTIffShipmentDetailResponse[]);
          }));
    }),
    startWith([] as FRTIffShipmentDetailResponse[])
  );

  // Listens to all hhg detail request and emits results for that request.
  hhgIFFShipmentDetailResults$ = this.hhgIFFShipmentDetailRequest.pipe(
    switchMap((iffMasterId) => {
      return this.http.get<HHGIffShipmentDetailResponse[]>(this.baseURI + '/iffDetailsList/get/' + iffMasterId + '/masterid')
        .pipe(
          catchError(e => {
            return of([] as HHGIffShipmentDetailResponse[]);
          }));
    }),
    startWith([] as HHGIffShipmentDetailResponse[])
  );
  private reportURI = this.baseURI + '/submitNegativeShipmentReport';

  updateHHGIffShipmentDetailRequestFn = (iffMasterId: string) => this.updateHHGIffShipmentDetailRequest(iffMasterId);
  updateFRTIffShipmentDetailRequestFn = (iffMasterId: string) => this.updateFRTIffShipmentDetailRequest(iffMasterId);

  // To emit value when there is new selection for HHG
  updateHHGIffShipmentDetailRequest(iffMasterId: string) {
    // this.hhgIFFShipmentDetailRequest.next(iffMasterId);
    return this.http.get<HHGIffShipmentDetailResponse[]>(this.baseURI + '/iffDetailsList/get/' + iffMasterId + '/masterid')
      .pipe(
        catchError(e => {
          return of([] as HHGIffShipmentDetailResponse[]);
        }));
  }

  // To emit value when there is new selection for FRT
  updateFRTIffShipmentDetailRequest(iffMasterId: string) {
    // this.frtIFFShipmentDetailRequest.next(iffMasterId);
    return this.http.get<FRTIffShipmentDetailResponse[]>(this.baseURI + '/frtiffDetails/get/' + iffMasterId + '/masterid')
      .pipe(
        catchError(e => {
          return of([] as FRTIffShipmentDetailResponse[]);
        }));
  }

  getIffMasterDetails(iffMasterId: string): Observable<any> {
    const iffDetailsUrl = this.baseURI + '/iffDetailsList' + '/get/' + iffMasterId + '/masterid';
    this.setUri(iffDetailsUrl);
    return this.get();
  }

  // call to server for iff Master list report
  getIffMasterListXlsx(iffMasterId: string): Observable<any> {
    const iffDetailsExcelUrl = this.baseURI + '/iffDetailsListxlsx' + '/get/' + iffMasterId + '/' + 'iffMasterId';
    return this.http.get<any>(iffDetailsExcelUrl);
  }

  // call to server for select box options
  getNegativeShipmentSelectOptions(): Observable<any> {
    const negativeShipmentSelection = this.baseURI + '/negativeShipmentSubmissionSelection';
    // console.log('Carrier rate proc URL: ' + negativeShipmentSelection);
    return this.http.get<any>(negativeShipmentSelection);
  }

  submitNegativeShipmentReport(formNegativeShipmentSelect: NegativeShipmentReportSubmission): Observable<any> {
    return this.http.post<any>(this.reportURI, formNegativeShipmentSelect, {headers: this.headers});
  }

  getHHGComprehensiveReport(reportingYear: number, reportingQuarter: number): Observable<any> {
    const iffDetailsUrl = this.baseURI + '/iffShipmentSummary' + '/hhgComprehensive/' + reportingYear + '/reportingyear/' + reportingQuarter + '/reportingQuarter';
    this.setUri(iffDetailsUrl);
    return this.get();
  }

  getHHGComprehensiveReportforRfsp(reportingYear: number, reportingQuarter: number, moveType: String, carrierId: number): Observable<any> {
        const iffDetailsUrl = this.baseURI + '/iffShipmentSummary' + '/rfspComprehensive/' + reportingYear + '/reportingyear/' + reportingQuarter + '/reportingQuarter/' + moveType + '/moveType/' + carrierId + '/carrierId';
        this.setUri(iffDetailsUrl);
        return this.get();
  }
  
  getSITComprehensiveReport(reportingYear: number, reportingQuarter: number): Observable<any> {
    const iffDetailsUrl = this.baseURI + '/iffShipmentSummary' + '/sitComprehensive/' + reportingYear + '/reportingyear/' + reportingQuarter + '/reportingQuarter';
    this.setUri(iffDetailsUrl);
    return this.get();
  }

  getFRTComprehensiveReport(reportingYear: number, reportingQuarter: number): Observable<any> {
    const iffDetailsUrl = this.baseURI + '/iffShipmentSummary' + '/frtComprehensive/' + reportingYear + '/reportingyear/' + reportingQuarter + '/reportingQuarter';
    this.setUri(iffDetailsUrl);
    return this.get();
  }
}


